<script>
//SampleSource https://codesandbox.io/s/suoyc?file=/src/Navigation.vue
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import Navigation from '@/components/EndUser/PartsCropperNavigation'

import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'
import SvgIconCheckWhite from '@/components/EndUser/svg/SvgIconCheckWhite'


export default {
    components: {
        Cropper,
        Navigation,
        //Svg
        SvgIconBack,
        SvgIconCheckWhite,
    },
    data() {
        return {
            zoom: 0,
        };
    },
    props: {
        imageData: Object,
    },
    emits:['setCropper', 'closeCropper'],
    methods: {
        defaultSize({ imageSize }) {
            return {
                width: imageSize.width,
                height: imageSize.height,
            };
        },
        stencilSize() {
            return {
                width: this.imageData.domWidth,
                height: this.imageData.domHeight,
            };
        },
        onChange(result) {
            const cropper = this.$refs.cropper;
            if (cropper) {
                const { coordinates, imageSize } = cropper;
                if (
                imageSize.width / imageSize.height >
                coordinates.width / coordinates.height
                ) {
                // Determine the position of slider bullet
                // It's 0 if the stencil has the maximum size and it's 1 if the has the minimum size
                this.zoom =
                    (cropper.imageSize.height - cropper.coordinates.height) /
                    (cropper.imageSize.height - cropper.sizeRestrictions.minHeight);
                } else {
                this.zoom =
                    (cropper.imageSize.width - cropper.coordinates.width) /
                    (cropper.imageSize.width - cropper.sizeRestrictions.minWidth);
                }
            }
        },
        onZoom(value) {
            const cropper = this.$refs.cropper;
            if (cropper) {
                if (cropper.imageSize.height < cropper.imageSize.width) {
                const minHeight = cropper.sizeRestrictions.minHeight;
                const imageHeight = cropper.imageSize.height;
                // Determine the current absolute zoom and the new absolute zoom
                // to calculate the sought relative zoom value
                cropper.zoom(
                    (imageHeight - this.zoom * (imageHeight - minHeight)) /
                    (imageHeight - value * (imageHeight - minHeight))
                );
                } else {
                const minWidth = cropper.sizeRestrictions.minWidth;
                const imageWidth = cropper.imageSize.width;
                cropper.zoom(
                    (imageWidth - this.zoom * (imageWidth - minWidth)) /
                    (imageWidth - value * (imageWidth - minWidth))
                );
                }
            }
        },
        cropImage() {
            const result = this.$refs.cropper.getResult();
            const imageURL = result.canvas.toDataURL(this.imageData.type);
            this.$store.state.register.crop.temp_image = imageURL;
            this.$emit('setCropper');
            this.$emit('closeCropper');
        },
        closeModal() {
            this.$emit('closeCropper');
        },
    },
}
</script>

<template>
    <div>
        <div class="modal_bg _on"></div>
        <div class="modal_container _cropper _open" tabindex="-1" >
            <div class="modal_wrap">
                <div class="inner">
                    <!--Contents-->
                    <div class="cropper_component-control">
                        <div class="title"><span>画像をトリミングする</span></div>
                        <button @click="closeModal" class="btn_svg-icon">
                            <SvgIconBack />
                        </button>
                        <button @click="cropImage" type="button" class="btn_link_c md_icon-text _white">
                            <div class="inner">
                                <span><div class="icon"><SvgIconCheckWhite /></div>決定</span>
                            </div>
                        </button>
                    </div>
                <!--item-->
                <div class="item-wrap">
                    <div class="item ">

                        <cropper
                            ref="cropper"
                            class="twitter-cropper"
                            background-class="twitter-cropper__background"
                            foreground-class="twitter-cropper__foreground"
                            image-restriction="stencil"
                            :stencil-size="stencilSize"
                            :stencil-props="{
                                lines: {},
                                handlers: {},
                                movable: false,
                                scalable: false,
                                previewClass: 'twitter-cropper__stencil',
                            }"
                            :transitions="false"
                            :debounce="false"
                            :default-size="defaultSize"
                            :min-width="150"
                            :min-height="150"
                            :src="imageData.src"
                            @change="onChange"
                        />
                        <navigation :zoom="zoom" @change="onZoom" />
                    </div>
                </div>

                    <!--/Contents-->
                </div>
                <div class="icon"></div>
            </div>
        </div>
    </div>
</template>